import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Button, Popover, Space, theme, Typography } from 'antd'
import {
  LinkOutlined,
  QuestionCircleOutlined,
  SendOutlined,
} from '@ant-design/icons'
import HelpClipboard from '../../resources/img/help-clipboard.svg'
import { openSafeUrl } from '../../lib/safeExternalUrl'
import { FEATURE_FLAGS } from '../../lib/featureFlagKeys'
import { useFeatureFlag } from '../../lib/useFeatureFlags'
import { HELP_ROOT, legacyHelpPath } from '../HelpCenter/helpTree'
import { helpCenterLinks } from '../../config/helpCenterLinks'

export function Help({
  text,
  description,
  showContactButton,
  helpLink,
  onContactClicked,
  // False on pages outside the login, which the in-app help center is not
  // reachable from.
  inAppHelp = true,
}) {
  const [open, setOpen] = useState(false)
  const { token } = theme.useToken()
  const { t } = useTranslation()
  const navigate = useNavigate()
  const helpCenterInApp =
    useFeatureFlag(FEATURE_FLAGS.HELP_CENTER_IN_APP_ENABLED) && inAppHelp

  function contactClicked() {
    onContactClicked()
    setOpen(false)
  }

  return (
    <Popover
      open={open}
      onOpenChange={(newOpen) => setOpen(newOpen)}
      overlayInnerStyle={{
        paddingLeft: token.paddingLG,
        paddingRight: token.paddingLG,
        paddingBlock: token.paddingMD,
        marginLeft: token.marginSM,
        marginRight: token.marginSM,
        maxWidth: 300,
      }}
      content={
        <Space direction="vertical" size="middle">
          <Typography.Title level={5} style={{ margin: 0 }}>
            {t('frontend:common.help')}
          </Typography.Title>
          <Space>
            {description ?? (
              <>
                {t('frontend:help.needHelp')}{' '}
                <img style={{ height: '40px' }} src={HelpClipboard} alt="" />
              </>
            )}
          </Space>
          <Space direction="vertical">
            <Button
              block
              onClick={() => {
                if (helpCenterInApp) {
                  navigate(legacyHelpPath(helpLink) ?? HELP_ROOT)
                } else {
                  openSafeUrl(helpLink ?? helpCenterLinks.de.home, '_blank')
                }
                setOpen(false)
              }}
            >
              <LinkOutlined /> {t('frontend:help.toDatabase')}
            </Button>
            {showContactButton && (
              <Button block onClick={contactClicked}>
                <SendOutlined /> {t('frontend:help.contact')}
              </Button>
            )}
          </Space>
        </Space>
      }
      arrow
      trigger="click"
      placement="bottom"
    >
      <Button
        type="text"
        style={{
          color: token.colorText,
          lineHeight: token.lineHeightLG,
        }}
      >
        <QuestionCircleOutlined style={{ fontSize: token.fontSizeLG }} />
        {/*<HelpIcon style={{ fontSize: token.fontSizeLG }} />*/}
        {text}
      </Button>
    </Popover>
  )
}
